<template>
    <div class="container">
        <div class="content-box">
            <div class="element-wrapper pb-0">
                <div class="element-header">
                    <div class="row ">
                        <div class="col-md-8 mr-auto">
                        <h3 class>Correio</h3>
                        </div>
                    </div>
                    <div v-if="faturasPendentes>0" class="row w-100">
                        <b-alert show variant="danger">Envio pro Correio pendente</b-alert>
                    </div>
                </div>
                <div class="">
                    <div class = "row">
                        <div class="col text-left">
                            <b-button @click="openModalEnviar" variant="primary">
                        Enviar Faturas
                            </b-button>
                        </div>
                        <div class="col text-right">
                            <b-button v-b-toggle.collapse-1 variant="primary">
                            <i class="fa fa-filter"></i>
                            Filtros
                            </b-button>
                        </div>
                    </div>
                    <b-collapse id="collapse-1" class="mt-2">
                        <b-card header="Filtros para aplicar">
                            <div class="container">
                                <div class="row">
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label>Nome Cliente</label>
                                            <input v-model="filtro.nomeCliente" type="text" class="form-control">
                                        </div>
                                    </div>
                                    <div class="col-4" v-if="isAdministrador">
                                        <label>Empresa</label>
                                        <multiselect
                                        v-model="filtro.empresa"
                                        label="name"
                                        value="_id"
                                        track-by="_id"
                                        placeholder="Selecione uma empresa"
                                        :showLabels="false"
                                        :options="empresas"
                                        ></multiselect>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label>Status Boleto</label>
                                            <multiselect v-model="filtro.statusBoleto" :multiple="true"
                                            :taggable="true" :options="statusBoleto" :showLabels="false"
                                            :hide-selected="true" select-label="" label="name" value="code" track-by="code"
                                            :searchable="false" placeholder="Selecione o status do Boleto"></multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label>Data Inicio Vencimento</label>
                                            <datepicker calendar-button-icon="fa fa-calendar-alt" clear-button bootstrap-styling calendar-button v-model="filtro.dataVencimentoInicial"></datepicker>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label>Data Fim Vencimento</label>
                                            <datepicker calendar-button-icon="fa fa-calendar-alt" clear-button bootstrap-styling calendar-button v-model="filtro.dataVencimentoFinal"></datepicker>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label>Tipo de Envio</label>
                                            <multiselect v-model="filtro.tipoEnvio"
                                            :taggable="true" :options="tipoEnvioFatura" label="name" value="name" track-by="name"
                                            :hide-selected="true" :showLabels="false"
                                            :searchable="false" placeholder="Selecione o tipo do envio"></multiselect>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <label>Fatura foi enviada </label>
                                        <div class="form-group">
                                            <multiselect v-model="filtro.dataEnvioExiste"
                                            :showLabels="false"
                                            :options="dataEnvioExiste"
                                            label="name" value="code" track-by="code"
                                            placeholder="Sim ou Não"></multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="row ">
                                    <div class="col ">
                                         <b-button @click="downloadExecelTelaPrincipal">Exportar</b-button>
                                    </div>
                                    <div class="col text-right">
                                        <b-link @click="limpar" class="mr-2">Limpar</b-link>
                                        <b-button v-b-toggle.collapse-1 @click="find" variant="primary">Aplicar</b-button>
                                    </div>
                                </div>
                            </div>
                        </b-card>
                    </b-collapse>
                </div>

                <div class="mt-3">
                    <b-card>
                        <div class="row">
                            <b-col class="my-1">
                            <b-pagination
                                v-if="totalRows > 10"
                                v-model="currentPage"
                                :total-rows="totalRows"
                                :per-page="perPage"
                                align="fill"
                                size="sm"
                                class="my-0"
                            ></b-pagination>
                            </b-col>
                        </div>
                        <b-table show-empty emptyText="Não há itens para exibir"
                        ref="table" id="my-table"
                        selectable
                        @row-selected="onRowTransacoes"
                        :current-page="currentPage"
                        :per-page="perPage"
                        select-mode="multi"
                        selected-variant="success"
                        :busy="loading" :items="faturas" sticky-header
                        :fields="fields" small
                        striped hover bordered>
                            <div slot="table-busy" class="text-center my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Carregando...</strong>
                            </div>
                            <template class="text-center" slot="[statusFatura]" slot-scope="row">
                                <b-badge :variant="getTextStatusFatura(row.item.fatura.vindiInfo.status)=='Pago'? 'success':'warning'">{{getTextStatusFatura(row.item.fatura.statusFatura)}}</b-badge>
                            </template>
                            <template class="text-center" slot="[formadePagamento]" slot-scope="row">
                                <b-badge variant="warning">{{getTextFormaPagamento(row.item.formadePagamento)}}</b-badge>
                            </template>
                            <template class="text-center" slot = "[RealizouEnvio]" slot-scope="row">
                                <b-badge :variant="getTextDataEnvio(row.item.fatura) === 'Sim' ? 'success' : 'warning'">{{getTextDataEnvio(row.item.fatura)}}</b-badge>
                            </template>
                            <template slot="[actions]" slot-scope="row">
                                <b-button title="Visualizar" variant="light" @click.stop=" $router.push({name: 'PedidoTransacoes', query:{id: row.item._id}})">
                                  <i class="fas fa-search"></i>
                                </b-button>
                            </template>
                        </b-table>
                    </b-card>
                </div>
            </div>
        </div>
        <b-modal
            id="modalEnvioFaturas"
            title="Envio faturas via Correio"
            size="lg"
            @ok="saveEnvioFatura"
            ref="modalTipoEnvio"
            ok-title="Salvar"
            cancel-title="Cancelar"
            >
            <div class="row">
                <div class="col" style="margin: 10px">
                    <div class="row">
                        <div class="col-4">
                            <div class="form-group">
                                <label>Data Inicio Vencimento</label>
                                <datepicker calendar-button-icon="fa fa-calendar-alt" clear-button bootstrap-styling calendar-button v-model="filtro.dataVencimentoInicial"></datepicker>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-group">
                                <label>Data Fim Vencimento</label>
                                <datepicker calendar-button-icon="fa fa-calendar-alt" clear-button bootstrap-styling calendar-button v-model="filtro.dataVencimentoFinal"></datepicker>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Nome Cliente</label>
                            <input v-model="filtro.nomeCliente" type="text" class="form-control">
                        </div>
                    </div>
                    <div class="row ">
                        <div class="col text-left">
                                <b-button @click="downloadExecel">Exportar</b-button>
                        </div>
                        <div class="col text-right">
                            <b-link @click="limpar" class="mr-2">Limpar</b-link>
                            <b-button @click="findCorreio" variant="primary">Aplicar</b-button>
                        </div>
                    </div>
                </div>
            </div>
            <b-card>
                <div class="row">
                    <b-col class="my-1">
                        <b-pagination
                            v-if="totalRowsEnvio > 10"
                            v-model="currentPageEnvio"
                            :total-rows="totalRowsEnvio"
                            :per-page="perPageEnvio"
                            align="fill"
                            size="sm"
                            class="my-0">
                        </b-pagination>
                    </b-col>
                </div>
               <b-table show-empty emptyText="Não há itens para exibir"
                ref="selectTable" id="selectTable"
                :current-page="currentPageEnvio"
                :per-page="perPageEnvio"
                @row-selected="onRowSelected"
                :hide-selected="true"
                selectable
                select-mode="multi"
                select-variant = "sucess"
                :busy="loading" :items="correio" sticky-header
                :fields = "fieldsCorreio" small striped hover bordered>
                    <div slot="table-busy" class="text-center my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                    <template class="text-center" slot="[statusFatura]" slot-scope="row">
                        <b-badge :variant="getTextStatusFatura(row.item.fatura.vindiInfo.status)=='Pago'? 'success':'warning'">{{getTextStatusFatura(row.item.fatura.statusFatura)}}</b-badge>
                    </template>
                    <template slot="[formadePagamento]" slot-scope="row">
                        {{getTextFormaPagamento(row.item.formadePagamento)}}
                    </template>
                    <template slot = "[RealizouEnvio]" slot-scope="row">
                        <b-badge :variant="getTextDataEnvio(row.item.fatura) === 'Sim' ? 'sim' : 'warning'">{{getTextDataEnvio(row.item.fatura)}}</b-badge>
                    </template>
                    <template slot="[actions]" slot-scope="row">
                        <b-button title="Visualizar" variant="light" @click.stop=" $router.push({name: 'PedidoDetail', query:{id: row.item._id}})">
                            <i class="fas fa-search"></i>
                        </b-button>
                    </template>
               </b-table>
               <div class="row">
                   <div class="col-2">
                       <b-button @click="selectAllRows" >Selecionar tudo</b-button>
                   </div>
                   <div class="col-2">
                       <b-button @click="clearSelected" >Limpar os Selecionados</b-button>
                   </div>
                    <div class="col-md  text-right">
                        <label for>Digite o numero da Nota Fiscal:</label>
                        <input type="text" v-model="notaFiscal"/>
                    </div>
               </div>
            </b-card>
        </b-modal>
    </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import XLSX from 'xlsx';
import datepicker from 'vuejs-datepicker'
import Multiselect from 'vue-multiselect'
import _ from 'lodash';
export default {
    async mounted(){
        if(this.empresas){
            const empresa = await axios.get(`/api/juridica/?select=name%20_id`);
            this.empresas = empresa.data
        }
        const faturasPendentes = await axios.get("/api/correioAtrasado");
        this.faturasPendentes = faturasPendentes.data
        this.$root.$on('bv::modal::hide', () => {
            this.selected = [];
            this.notaFiscal = null
            this.limpar()
            this.find()
        })
    },
    components:{
        datepicker,
        Multiselect
    },
    computed:{
        loading() {
            return this.$store.getters.loadingTable;
        },
        user() {
            return this.$store.getters.user;
        },
        isAdministrador () {
            return this.$store.getters.isAdministrador;
        },
        empresa () {
            return this.$store.getters.empresa || {}
        },
    },
    data(){
        return {
            faturasPendentes:0,
            empresas:{},
            filtro:{},
            totalRows: 1,
            totalRowsEnvio:1,
            currentPage: 1,
            currentPageEnvio:1,
            perPage: 10,
            perPageEnvio: 10,
            selected:[],
            notaFiscal:null,
            fields: [
                {key: 'fatura.dataVencimento',class: 'text-center', label: 'Vencimento Fatura', sortable: true, formatter: this.createdAtFormatter},
                {key: 'juridica.name',class: 'text-center', label: 'Empresa', sortable: true},
                {key: 'fatura.dataEnvio',class: 'text-center', label: 'Data Envio', sortable:true, formatter: this.createdAtFormatter},
                {key: 'statusFatura', class: 'text-center', label: 'Status Fatura', sortable:true},
                {key: "client.name",class: 'text-center', label: "Nome Cliente", sortable:true},
                {key: 'formadePagamento', class: 'text-center',label: 'Método Pagamento', sortable:true},
                {key: "tipoEnvioFatura",class: 'text-center',label:"Forma de Envio",sortable:true,formatter:this.getFormaEnvio},
                {key: "RealizouEnvio",class: 'text-center', label:"",sortable:true},
                {key: "actions",label: ""}
            ],
            statusBoleto:[{code: 'paid', name: 'Pago'}, {code: 'pending', name: 'Aguardando pagamento'},{code: 'rejected', name: 'Rejeitado'}, {code: 'failure', name: 'Falha'}, {code: 'processing', name: 'Processando'}],
            tipoEnvioFatura:[{name:"E-mail"},{name:"Whatsapp"},{name:"Correio"}],
            fieldsCorreio: [
                {key: 'fatura.dataVencimento',class: 'text-center', label: 'Vencimento Fatura', sortable: true, formatter: this.createdAtFormatter},

                {key: 'juridica.name',class: 'text-center', label: 'Empresa', sortable: true},
                {key: 'statusFatura', class: 'text-center', label: 'Status Fatura', sortable:true},
                {key: 'createdAt',class: 'text-center', label: 'Cadastro Pedido', sortable:true, formatter: this.createdAtFormatter},
                {key: "client.name",class: 'text-center', label: "Nome Cliente", sortable:true},
                {key: "client.cpf",class: 'text-center', label: "Cliente Cpf", sortable:true},
                {key: 'formadePagamento', class: 'text-center',label: 'Método Pagamento', sortable:true},
                {key: 'fatura',class: 'text-center',label: "Data Envio Fatura",sortable:true, formatter: this.createdAtFormatterFatura},
            ],
            dataEnvioExiste:[{code:'false',name:"Não"},{code:'true',name:"Sim"}]
        }
    },
    methods:{
        find(){
            this.$store.dispatch('setLoading', true);
            this.$store.dispatch("setLoadingTable", true);
            this.$store.dispatch('setLoading', false);
            this.$root.$emit('bv::refresh::table', 'my-table')
            this.$store.dispatch("setLoadingTable", false);
        },
        findCorreio(){
            this.$store.dispatch('setLoading', true);
            this.$store.dispatch("setLoadingTable", true);
            this.$store.dispatch('setLoading', false);
            this.$root.$emit('bv::refresh::table', 'selectTable')
            this.$store.dispatch("setLoadingTable", false);
        },
        limpar(){
            this.filtro ={}
        },
        async downloadExecel(){
            var filtro = {}
            filtro.dataInicial = moment().add("20","day").toDate();
            filtro.dataInicial= this.createdAtFormatter(filtro.dataInicial)
            filtro.tipoEnvio = "Correio";
            filtro.dataEnvioExiste="Não";
            filtro.statusBoleto= ["pending"];
            const promise = await axios.get('/api/correio-export',
                {params:filtro}
            )
            // eslint-disable-next-line
            const correio = promise.data
            var correioxlsx = XLSX.utils.json_to_sheet(correio);
            var wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, correioxlsx, 'Correio')
            XLSX.writeFile(wb, 'Correio.xlsx')
        },
        async downloadExecelTelaPrincipal(){
            var filtro =  _.cloneDeep(this.filtro);
            if(filtro.empresa){
                filtro.empresa = filtro.empresa._id;
            }
            if(filtro.statusBoleto){
                filtro.statusBoleto = filtro.statusBoleto.map(st =>
                    st.code
                )
            }
            if(filtro.dataVencimentoInicial && filtro.dataVencimentoFinal){
                filtro.dataVencimentoInicial=this.createdAtFormatter(filtro.dataVencimentoInicial)
                filtro.dataVencimentoFinal=this.createdAtFormatter(filtro.dataVencimentoFinal)
            }
            if(filtro.tipoEnvio){
                filtro.tipoEnvio = filtro.tipoEnvio.name
            }
            if(filtro.dataEnvioExiste){
                filtro.dataEnvioExiste=filtro.dataEnvioExiste.name
            }
            const promise = await axios.get('/api/correio-export',
                {params:filtro}
            )
            const correio = promise.data
            var correioxlsx = XLSX.utils.json_to_sheet(correio);
            var wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, correioxlsx, 'Correio')
            XLSX.writeFile(wb, 'Faturas.xlsx')
        },
        faturas(ctx){
            var filtro =  _.cloneDeep(this.filtro);
            if(filtro.empresa){
                filtro.empresa = filtro.empresa._id;
            }
            if(filtro.statusBoleto){
                filtro.statusBoleto = filtro.statusBoleto.map(st =>
                    st.code
                )
            }
            if(filtro.dataVencimentoInicial && filtro.dataVencimentoFinal){
                filtro.dataVencimentoInicial=this.createdAtFormatter(filtro.dataVencimentoInicial)
                filtro.dataVencimentoFinal=this.createdAtFormatter(filtro.dataVencimentoFinal)
            }
            if(filtro.tipoEnvio){
                filtro.tipoEnvio = filtro.tipoEnvio.name
            }
            if(filtro.dataEnvioExiste){
                filtro.dataEnvioExiste=filtro.dataEnvioExiste.name
            }
            filtro.limit = ctx.perPage;
            filtro.page = ctx.currentPage;

            this.currentPage = ctx.currentPage;

            const promise = axios.get('/api/correio',
                {params:filtro}
            )
            // eslint-disable-next-line
            console.log(promise)
            return promise.then(response => {
                let result = response.data;
                this.totalRows = result.totalCount;

                const items = result.data;
                // eslint-disable-next-line
                console.log(items)
                return items || []
            });
        },
        openModalEnviar(){
            this.$store.dispatch('setLoading', true);
            this.limpar();
            this.$store.dispatch('setLoading', false);
            this.$bvModal.show('modalEnvioFaturas');
            this.findCorreio()
        },
        correio(ctx){
            var filtro = _.cloneDeep(this.filtro);
             if(filtro.dataVencimentoInicial && filtro.dataVencimentoFinal){
                filtro.dataVencimentoInicial=this.createdAtFormatter(filtro.dataVencimentoInicial)
                filtro.dataVencimentoFinal=this.createdAtFormatter(filtro.dataVencimentoFinal)
            }else{
                filtro.dataInicial = moment().add("20","day").toDate();
                filtro.dataInicial= this.createdAtFormatter(filtro.dataInicial);
            }
            filtro.limit = ctx.perPage;
            filtro.tipoEnvio = "Correio";
            filtro.dataEnvioExiste="Não";


            filtro.statusBoleto= ["pending"];
            filtro.page = ctx.currentPage;
            // eslint-disable-next-line
            console.log(filtro)
            this.currentPageEnvio = ctx.currentPage;
            const promise = axios.get('/api/correio',
                {params:filtro}
            )
            // eslint-disable-next-line
            console.log(this.user)
            return promise.then(response => {
                let result = response.data;
                this.totalRowsEnvio = result.totalCount;

                const items = result.data;
                return items || []
            });
        },
        async saveEnvioFatura(){

            const selecionado = this.selected;
            var atualizar = [];
            var enviadoPor = this.user.name;
            selecionado.forEach((pedido)=>{
                pedido.fatura.dataEnvio = moment().format()
                pedido.fatura.notaFiscal = this.notaFiscal;
                pedido.fatura.enviadoPor = enviadoPor;
                atualizar.push(pedido.fatura)
            })
            var promise = await axios.post('/api/correio',{fatura:atualizar})
        // eslint-disable-next-line
            console.log(promise)
            const faturasPendentes = await axios.get("/api/correioAtrasado");
            this.faturasPendentes = faturasPendentes.data
            this.openModalEnviar()
        },
        createdAtFormatter(value){
            if (value) {
                return moment(value).format("DD/MM/YYYY");
            }
            return ''
        },
        createdAtFormatterFatura(fatura){
            if(fatura){
                if (fatura.dataEnvio) {
                    return moment(fatura.dataEnvio).format("DD/MM/YYYY");
                    }
                }
            return ''
        },
        getTextDataEnvio(fatura) {
            if(fatura){
                if(fatura.dataEnvio){
                    return "Sim"
                }
            }
            return "Não"
        },
        getFormaEnvio(formaEnvio){
            var teste = "";
            if(formaEnvio){
                formaEnvio.forEach(tipoEnvio=>{
                    if(teste!= ""){
                        teste  = teste+", "+ tipoEnvio
                    }else{
                        teste = tipoEnvio
                    }

                })
                return teste;
            }
            else{
                return teste;
            }

        },
        getTextFormaPagamento(formaPagamento) {
            switch (formaPagamento) {
                case 'cartaoCredito':
                return 'Cartão Crédito'
                default:
                return formaPagamento;
            }
        },
        getTextStatusFatura(statusVindi){
            switch (statusVindi) {
                case 'processing':
                    return 'Processando pagamento'
                case 'failure':
                    return 'Falha ao processar pagamento'
                case 'rejected':
                    return 'Pagamento rejeitado'
                case 'waiting':
                    return 'Aguardando pagamento'
                case 'pending':
                    return 'Aguardando pagamento'
                case 'success':
                case 'paid':
                    return 'Pago'
                default:
                    return statusVindi
            }
        },
        onRowSelected(items) {
            this.selected = items
        },
        onRowTransacoes(items){
            let pedido = items[0];
            this.$router.push({name: 'PedidoTransacoes', query:{id: pedido._id}});
        },
        selectAllRows() {
            this.$refs.selectTable.selectAllRows()
        },
        clearSelected() {
            this.$refs.selectTable.clearSelected()
        }
    }
}
</script>
<style scoped>
.b-table-sticky-header {
  overflow-y: auto;
  max-height: none;
}
</style>
